import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import StepPageLayout from 'shared/StepPageLayout'
import useStyles from 'shared/hooks/useStyle'

import styles from './TakePicture.style'

const propTypes = {
    step: PropTypes.shape({
        stepTitle: PropTypes.string.isRequired,
        isRequired: PropTypes.bool.isRequired,
    }).isRequired,
    onStart: PropTypes.func.isRequired,
    isNested: PropTypes.bool,
}

const TakePicture = ({
    step,
    onStart,
    isNested = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyles(styles)

    return (
        <StepPageLayout
            title={t(`processDefinition:${step.stepTitle}`)}
            isRequired={step.isRequired}
            isAnswered={false}
            isNested={isNested}
        >
            <div css={classes.form}>
                <div css={classes.actions}>
                    <Button
                        data-testid="take-picture-button"
                        css={classes.button}
                        onClick={onStart}
                    >
                        {t('TAKE_PICTURE')}
                    </Button>
                </div>
            </div>
        </StepPageLayout>
    )
}

TakePicture.propTypes = propTypes

export default TakePicture
